/**
 * Tracks errors already logged by the fetch patch to prevent double-logging.
 * Extracted to a separate module to avoid circular dependencies.
 */

const loggedErrors = new WeakSet<Error>();

export const markErrorAsLogged = (error: Error): void => {
  loggedErrors.add(error);
};

export const isErrorLoggedByFetchPatch = (error: unknown): boolean => error instanceof Error && loggedErrors.has(error);
